const Header = () => {
  return (
    <header className="py-2 w-full">
      <div className='container mx-auto '>
        <div className='flex justify-between items-center '>
          <h2 className='text-gradient text-lg'>Patrycja B. Zalas</h2>
          <a href="mailto:zalas.patrycja@gmail.com">
            <button className='btn btn-sm'>Contact me</button>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
